// extracted by mini-css-extract-plugin
module.exports = {"inlineParam":"_93444fe79c--inlineParam--1AaT5"};